"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _lodash = require("lodash");
var _bowser = _interopRequireDefault(require("bowser"));
var _models = require("@seedlang/models");
var _utils = require("@seedlang/utils");
var _audio_recorder_store = _interopRequireDefault(require("./audio_recorder_store"));
var _base_user_input_store = _interopRequireDefault(require("./base_user_input_store"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MEDIA_SESSION_KEY = 'seedlang-active-media-session';
var MEDIA_SESSION_ID = "".concat(Date.now(), "-").concat(Math.random());
var activeUserInputStore = null;
var claimMediaSession = function claimMediaSession(store) {
  if (activeUserInputStore && activeUserInputStore !== store && activeUserInputStore.isRecording) {
    activeUserInputStore.stopRecording();
  }
  activeUserInputStore = store;
  window.localStorage.setItem(MEDIA_SESSION_KEY, MEDIA_SESSION_ID);
};
var releaseMediaSession = function releaseMediaSession(store) {
  if (activeUserInputStore !== store) {
    return;
  }
  activeUserInputStore = null;
  if (window.localStorage.getItem(MEDIA_SESSION_KEY) === MEDIA_SESSION_ID) {
    window.localStorage.removeItem(MEDIA_SESSION_KEY);
  }
};
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function' && typeof window.localStorage !== 'undefined' && typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
  window.addEventListener('storage', function (event) {
    var _activeUserInputStore;
    if (event.key === MEDIA_SESSION_KEY && event.newValue && event.newValue !== MEDIA_SESSION_ID && (_activeUserInputStore = activeUserInputStore) !== null && _activeUserInputStore !== void 0 && _activeUserInputStore.isRecording) {
      activeUserInputStore.stopRecording();
    }
  });
  document.addEventListener('visibilitychange', function () {
    var _activeUserInputStore2;
    if (document.hidden && (_activeUserInputStore2 = activeUserInputStore) !== null && _activeUserInputStore2 !== void 0 && _activeUserInputStore2.isRecording) {
      activeUserInputStore.stopRecording();
    }
  });
}
var WebUserInputStore = (_class = /*#__PURE__*/function (_BaseUserInputStore) {
  function WebUserInputStore() {
    var _this;
    var _params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, WebUserInputStore);
    _this = _callSuper(this, WebUserInputStore, [_objectSpread(_objectSpread({}, _params), {}, {
      isNative: false
    })]);
    (0, _initializerDefineProperty2["default"])(_this, "audioStreamInstantiated", _descriptor, _this);
    (0, _initializerDefineProperty2["default"])(_this, "objectUrl", _descriptor2, _this);
    (0, _initializerDefineProperty2["default"])(_this, "data", _descriptor3, _this);
    (0, _initializerDefineProperty2["default"])(_this, "stream", _descriptor4, _this);
    (0, _initializerDefineProperty2["default"])(_this, "audio", _descriptor5, _this);
    _this.setupAudio = function (callback) {
      if (_this.mediaType !== 'audio') {
        _this.getUserMediaWithCallback({
          audio: true,
          video: false
        }, callback);
        _this.mediaType = 'audio';
      }
    };
    _this.recordAudio = function () {
      if (_this.mediaType === 'audio' && _this.recorder) {
        _this.startRecording();
      } else {
        _this.setupAudio(_this.recordAudio);
      }
    };
    _this.getUserMediaWithCallback = function (params, callback) {
      if (callback) {
        _this.afterDeviceGrantedAccess = callback;
      }
      if (!_bowser["default"].ios && !_bowser["default"].safari) {
        (0, _utils.getUserMedia)(params, _this.onDeviceGrantedAccess, _this.onDeviceDeniedAccess);
      }
    };
    _this.onDeviceGrantedAccess = function (stream) {
      if (_this.disposed || document.hidden) {
        stream.getTracks().forEach(function (track) {
          return track.stop();
        });
        _this.mediaType = null;
        return;
      }
      _this.streams.push(stream);
      _this.stream = stream;
      _this.setupRecorder();
      if ((0, _lodash.isFunction)(_this.afterDeviceGrantedAccess)) {
        _this.afterDeviceGrantedAccess(stream);
        _this.afterDeviceGrantedAccess = null;
      }
    };
    _this.setupRecorder = function () {
      if (_this.parent && _this.parent.deviceDeniedAccess) {
        return;
      }
      if (!_this.audioStreamInstantiated) {
        _this.audioStreamInstantiated = true;
        if (!_this.audioStream) {
          _this.audioStream = new _models.AudioStream();
        }
        if (_this.audioStream) {
          _this.audioStream.onStreamSuccess(_this.stream, _this.onAudioLevelUpdate);
        }
      }
      if (_this.mediaType === 'audio') {
        _this.recorder = new _audio_recorder_store["default"](_this.stream, _this.onHandleData);
      }
    };
    _this.clearAudioStream = function () {
      if (_this.audioStream) {
        _this.audioStream.cleanup();
        _this.audioStream = null;
      }
      _this.mediaType = null;
      _this.audioStreamInstantiated = false;
      (0, _lodash.each)(_this.streams, function (stream) {
        stream.getTracks().forEach(function (track) {
          if (track.kind === 'audio') {
            track.stop();
          }
        });
      });
      _this.streams = [];
      _this.stream = null;
    };
    _this.onHandleData = function (event) {
      if (event.data && event.data.size > 0) {
        _this.data.push(event.data);
      }
    };
    _this.onAudioLevelUpdate = function (audioLevel) {
      _this.audioLevel = audioLevel;
      if (_this.normalizedAudioLevel > _this.maxAudioLevel) {
        _this.maxAudioLevel = _this.normalizedAudioLevel;
      }
    };
    _this.startRecording = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.recorder) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            if (!document.hidden) {
              _context.next = 2;
              break;
            }
            _this.clearAudioStream();
            return _context.abrupt("return");
          case 2:
            _this.data = [];
            _this.clearObjectUrl();
            _this.startSecondsElapsed();
            _this.isRecording = true;
            _this.hasFinishedRecording = false;
            claimMediaSession(_this);
            if (_this.audioStream) {
              _this.audioStream.startMonitor();
            }
            _this.recorder.record();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    _this.stopRecording = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_this.stopRecordingPromise) {
        return _this.stopRecordingPromise;
      }
      _this.stopRecordingPromise = _this.finishStoppingRecording(params)["finally"](function () {
        _this.stopRecordingPromise = null;
      });
      return _this.stopRecordingPromise;
    };
    _this.finishStoppingRecording = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var params,
        _args2 = arguments;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            _this.autoPlay = params.autoPlay;
            if (_this.isRecording) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            _this.stopSecondsElapsed();
            _this.audioLevel = 0;
            _this.endRecordingTimestamp = +new Date();
            _this.isRecording = false;
            _this.hasFinishedRecording = false;
            if (_this.audioStream) {
              _this.audioStream.stopMonitor();
            }
            if (!_this.recorder) {
              _context2.next = 2;
              break;
            }
            _context2.next = 2;
            return _this.recorder.stop();
          case 2:
            if (!params.skipCreateObjectURL && _this.hasRecording) {
              _this.clearObjectUrl();
              _this.objectUrl = _this.createObjectURL(_this.createBlob());
            }
            _this.hasFinishedRecording = true;
            releaseMediaSession(_this);
            _this.clearAudioStream();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    _this.getFormData = function () {
      var formData = new FormData();
      formData.append('blob', _this.createBlob());
      return formData;
    };
    _this.createBlob = function () {
      return _this.recorder.createBlob(_this.data);
    };
    _this.setupAudioPlayer = function (audioEl, url, duration) {
      _this.clearAudioPlayer();
      _this.durationFromDatabase = duration;
      _this.audio = audioEl;
      if (_this.hasRecording) {
        _this.setUrl(_this.objectUrl);
      } else if (url) {
        _this.setUrl(url);
      }
    };
    _this.setUrl = function (url) {
      if (_this.audio) {
        _this.url = url;
        _this.audio.src = url;
        _this.audio.addEventListener('ended', _this.onEnd);
      }
    };
    _this.onTogglePlay = function () {
      _this.playing ? _this.pause() : _this.play();
    };
    _this.play = function () {
      if (!_this.audio || !_this.hasRecording && !_this.hasUrl) {
        return;
      }
      var promise = _this.audio.play();
      if (promise !== undefined) {
        promise.then(function () {
          _this.playing = true;
          _this.startPlayingTimestamp = +new Date();
          clearInterval(_this.interval);
          _this.interval = setInterval(_this.updateTimer, 50);
        })["catch"](function (error) {
          throw error;
        });
      }
    };
    _this.updateTimer = function () {
      if (_this.audio) {
        _this.currentTime = _this.audio.currentTime;
      }
    };
    _this.pause = function () {
      if (!_this.playing || !_this.audio) {
        return;
      }
      _this.playing = false;
      _this.pausePlayingTimestamp = +new Date();
      clearInterval(_this.interval);
      _this.audio.pause();
    };
    _this.createObjectURL = function (file) {
      if (window.webkitURL) {
        return window.webkitURL.createObjectURL(file);
      }
      if (window.URL && window.URL.createObjectURL) {
        return window.URL.createObjectURL(file);
      }
      return null;
    };
    _this.clearObjectUrl = function () {
      if (_this.objectUrl && typeof window !== 'undefined' && window.URL && window.URL.revokeObjectURL) {
        window.URL.revokeObjectURL(_this.objectUrl);
      }
      _this.objectUrl = null;
    };
    _this.clearAudioPlayer = function () {
      clearInterval(_this.interval);
      if (_this.audio) {
        _this.audio.pause();
        _this.audio.removeEventListener('ended', _this.onEnd);
        _this.audio.removeAttribute('src');
        _this.audio.load();
        _this.audio = null;
      }
    };
    _this.cleanupOffscreen = function () {
      if (_this.cleanupPromise) {
        return _this.cleanupPromise;
      }
      _this.cleanupPromise = _this.finishCleanupOffscreen()["finally"](function () {
        _this.cleanupPromise = null;
      });
      return _this.cleanupPromise;
    };
    _this.finishCleanupOffscreen = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!_this.stopRecordingPromise) {
              _context3.next = 2;
              break;
            }
            _context3.next = 1;
            return _this.stopRecordingPromise;
          case 1:
            _context3.next = 5;
            break;
          case 2:
            if (!_this.isRecording) {
              _context3.next = 4;
              break;
            }
            _context3.next = 3;
            return _this.stopRecording({
              skipCreateObjectURL: true
            });
          case 3:
            _context3.next = 5;
            break;
          case 4:
            releaseMediaSession(_this);
            _this.clearAudioStream();
          case 5:
            if (_this.data && _this.data.length > 0) {
              _this.data = [];
            }
            _this.clearObjectUrl();
            _this.clearAudioPlayer();
            _this.resetRecordingState();
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    _this.onSoftReset = function () {
      _this.resetRecordingState();
      _this.data = [];
      _this.clearObjectUrl();
      _this.clearAudioPlayer();
    };
    _this.onReset = function () {
      _this.pause();
      _this.playing = false;
      _this.currentTime = 0;
      _this.initialPlayHasFinished = false;
      _this.onSoftReset();
    };
    _this.onEnd = function () {
      clearInterval(_this.interval);
      _this.currentTime = 0;
      _this.playing = false;
      _this.initialPlayHasFinished = true;
    };
    _this.resetForNewRecording = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      return _regenerator["default"].wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return _this.cleanupOffscreen();
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    _this.dispose = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      return _regenerator["default"].wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this.disposed = true;
            _context5.next = 1;
            return _this.cleanupOffscreen();
          case 1:
            _this.recorder = null;
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    _this.onDeviceDeniedAccess = function () {
      _this.mediaType = null;
      _this.afterDeviceGrantedAccess = null;
      if (_this.parent) {
        _this.parent.set('deviceDeniedAccess', true);
      }
    };
    _this.seek = function (percentage) {
      if (!_this.audio || !_this.audio.duration) {
        return;
      }
      var nextTime = percentage / 100 * _this.audio.duration;
      if (Number.isFinite(nextTime)) {
        _this.audio.currentTime = nextTime;
        _this.currentTime = nextTime;
      }
    };
    _this.mediaType = null;
    _this.streams = [];
    _this.disposed = false;
    _this.cleanupPromise = null;
    _this.stopRecordingPromise = null;
    return _this;
  }
  (0, _inherits2["default"])(WebUserInputStore, _BaseUserInputStore);
  return (0, _createClass2["default"])(WebUserInputStore, [{
    key: "hasObjectUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.objectUrl);
    }
  }, {
    key: "hasRecording",
    get: function get() {
      return (0, _utils.isPresent)(this.data) && this.data.length > 0;
    }
  }]);
}(_base_user_input_store["default"]), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioStreamInstantiated", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "objectUrl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stream", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audio", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasObjectUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRecording"), _class.prototype), _class);
var _default = exports["default"] = WebUserInputStore;